import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import CommodityBid from "@/pages/CommodityBid";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CommodityBid />} />
          <Route path="/workspace" element={<Placeholder title="Your Workspace" subtitle="Workspace creation flow is coming soon." />} />
          <Route path="/demo" element={<Placeholder title="Book a Demo" subtitle="Talk to our procurement team. Coming soon." />} />
          <Route path="/contact" element={<Placeholder title="Contact" subtitle="We'll be reachable here soon." />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
